<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { redirectAfterAuth } from '@/utils/routeAccess'

export default {
  name: 'App',
  computed: {
    ...mapStores(useAuthStore)
  },
  data() {
    return {}
  },
  created() {
    try {
      // Initialize auth store
      const authStore = this.authStore

      // Check authentication on app start.
      // Dùng window.location.pathname (URL trình duyệt thật) thay vì this.$route.path:
      // main.js gọi app.mount() ngay lập tức, KHÔNG đợi router.isReady() — nên tại thời
      // điểm created() này chạy, Vue Router có thể chưa resolve xong điều hướng đầu tiên
      // và this.$route.path vẫn còn là giá trị mặc định "/", khiến publicPaths.includes(...)
      // sai và App.vue tự đá nhầm về /login trước khi router kịp vào đúng route (vd:
      // /google-oauth-callback, /facebook-oauth-callback khi chưa đăng nhập).
      const token = localStorage.getItem('token')
      const user = localStorage.getItem('user')
      const currentPath = window.location.pathname
      const publicPaths = ['/login', '/privacy-policy', '/terms-of-service', '/contact', '/facebook-oauth-callback', '/google-oauth-callback']
      // Các trang callback OAuth tự quản lý luồng đăng nhập riêng (nhận code/token mới) —
      // không được để refreshUserData() bằng token cũ (nếu còn sót trong localStorage) chạy
      // song song và 401 ngang, vì lỗi đó sẽ hard-redirect /login trước khi flow OAuth kịp xong.
      const isOAuthCallbackPath = currentPath === '/facebook-oauth-callback' || currentPath === '/google-oauth-callback'
      if (!token && !publicPaths.includes(currentPath)) {
        this.$router.push('/login')
        return
      }
      if (token && user) {
        try {
          authStore.token = token
          authStore.user = JSON.parse(user)
          authStore.permissions = authStore.user.permissions || []
          authStore.isAuthenticated = true
        } catch (parseError) {
          console.error('Failed to parse user data:', parseError)
          authStore.logout()
        }
      }
      // Khi F5: gọi API /api/user để cập nhật thông tin user và role permission
      if (token && !isOAuthCallbackPath) {
        authStore.refreshUserData()
      }
      // Redirect logic
      if (token && currentPath === '/login') {
        redirectAfterAuth(this.$router, authStore).catch((error) => {
          console.error('Redirect after auth failed:', error)
        })
      }
    } catch (error) {
      console.error('Error in App.vue created:', error)
      this.$router.push('/login')
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
  min-height: 100vh;
}
</style>